import { ChangeDetectorRef, Component, DestroyRef, Inject, OnInit } from '@angular/core';
import { CoreFormComponent } from '@app/core/components/core-form/core-form.component';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { ProfileService } from '@app/profile-feature/profile.service';
import { transition, trigger, useAnimation } from '@angular/animations';
import { HideAnimation, showAnimation } from '@app/shared/animations/transform-opacity';
import { SharedCoreFormService } from '@app/shared/services/shared-core-form.service';
import { GroupByPipe } from 'ngx-pipes';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CoreFormContentComponent } from '@app/shared/components/core-form-content/core-form-content.component';
import { FormFooterComponent } from '@app/shared/components/form-footer/form-footer.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-profile-form',
  templateUrl: 'profile-form.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    CoreFormContentComponent,
    FormFooterComponent
  ],
  animations: [
    trigger('showHide', [
      transition('void => *', [
        useAnimation(showAnimation, {
          params: {
            timings: '200ms ease-in-out',
            transform: 'translateY(-10%)',
            opacity: '0'
          }
        })
      ]),
      transition('* => void', [
        useAnimation(HideAnimation, {
          params: {
            timings: '200ms 200ms ease-in-out',
            transform: 'translateY(-10%)',
            opacity: '0'
          }
        })
      ])
    ])
  ]
})
export class ProfileFormComponent extends CoreFormComponent implements OnInit {
  formValid: boolean = true;
  constructor(
    service: ProfileService,
    fb: FormBuilder,
    activatedRoute: ActivatedRoute,
    groupByPipe: GroupByPipe,
    sharedCoreFormService: SharedCoreFormService,
    // changeDetectorRef: ChangeDetectorRef,
    dialogRef: MatDialogRef<ProfileFormComponent>,
    private destroyRef: DestroyRef,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) {
    super(
      service,
      fb,
      activatedRoute,
      groupByPipe,
      sharedCoreFormService,
      // changeDetectorRef,
      dialogRef,
      dialogData
    );
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.isEdit = true;
    this.service
      .apiRequest('GET', 'users/profile')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(res => {
        this.formInjectValues(res.data);
      });
  }

  refactorItem(item: any): any {
    super.refactorItem(item);
    if (item.photo) {
      this.previewImage = item.photo;
    }
    return item;
  }

  prepareFormAfterSubmit() {
    // if (this.form.value.position === 'administrator') {
    //   this.form.value.position = 'employee';
    //   this.form.value.role = '2';
    // }
  }
}
